import React from "react";
import LandlordForm from "./LandlordForm";

export default function EditLandlord(){
    return <LandlordForm type="Edit" />
}